import SphInput from './Input.vue';
import SphInputSimple from './internal/Input.vue';

export { SphInput, SphInputSimple };
export default SphInput;
